module.exports = class SituationGoalForm {

    constructor(form) {

        this.form = form;
        this.inputs = this.form.querySelectorAll("input, select, textarea");

        this.inputs.forEach((input) => {

            input.addEventListener("change", this.Update.bind(this));

        });

        this.Update();

    }

    IsCompleted() {

        for (let i = 0; i < this.inputs.length; i++) {

            if (!this.inputs[i].value) return false;

        }

        return true;

    }

    Update() {

        this.form.dataset.completed = this.IsCompleted() ? 1 : 0;

    }
}